/**
 * HreflangTags.js — Injects hreflang <link> tags for all 6 supported locales.
 *
 * Usage:
 *   <HreflangTags baseDomain="gaspineortho.com" pathWithoutLocale="/atlanta/car-accident-doctor" />
 *
 * Generates:
 *   <link rel="alternate" hreflang="en" href="https://gaspineortho.com/atlanta/car-accident-doctor" />
 *   <link rel="alternate" hreflang="es" href="https://gaspineortho.com/es/atlanta/car-accident-doctor" />
 *   ... (pt, ko, ja, fr)
 *   <link rel="alternate" hreflang="x-default" href="https://gaspineortho.com/atlanta/car-accident-doctor" />
 */

import React from "react";
import { Helmet } from "react-helmet-async";

const HREFLANG_LOCALES = [
  { code: "en", prefix: "" },
  { code: "es", prefix: "/es" },
  { code: "pt", prefix: "/pt" },
  { code: "ko", prefix: "/ko" },
  { code: "ja", prefix: "/ja" },
  { code: "fr", prefix: "/fr" },
];

export default function HreflangTags({ baseDomain, pathWithoutLocale = "/" }) {
  if (!baseDomain) return null;

  // Normalize path: ensure leading slash, strip trailing slash except root
  const cleanPath = pathWithoutLocale.startsWith("/")
    ? pathWithoutLocale
    : `/${pathWithoutLocale}`;

  return (
    <Helmet>
      {HREFLANG_LOCALES.map(({ code, prefix }) => {
        const href = `https://${baseDomain}${prefix}${cleanPath}`;
        return (
          <link
            key={code}
            rel="alternate"
            hrefLang={code}
            href={href}
          />
        );
      })}
      {/* x-default points to English (canonical) */}
      <link
        rel="alternate"
        hrefLang="x-default"
        href={`https://${baseDomain}${cleanPath}`}
      />
    </Helmet>
  );
}
